export const videoHostings = [
  {
    label: 'YouTube',
    name: 'youtube',
    url: 'https://youtu.be/%id',
  },
  {
    label: 'Vimeo',
    name: 'vimeo',
    url: 'https://vimeo.com/%id',
  },
  {
    label: 'ВКонтакте',
    name: 'vk',
    url: 'https://vkvideo.ru/video%id',
  },
  {
    label: 'Одноклассники',
    name: 'ok',
    url: 'https://ok.ru/%id',
  },
  {
    label: 'RuTube',
    name: 'rutube',
    url: 'https://rutube.ru/video/%id/?r=plwd',
  },
  {
    label: 'Дзен',
    name: 'dzen',
    url: 'https://dzen.ru/video/watch/%id',
  },
];

export function getVideoUrl(provider, id) {
  const videoHostingsHash = videoHostings.reduce((acc, item) => {
    acc[item.name] = item;
    return acc;
  }, {});
  return videoHostingsHash[provider].url.replace('%id', id);
}
